import { ISvgProps } from '@/icons/utils/svg-types'

export function parseSvgStyle(props: ISvgProps): React.CSSProperties {
    const rawWidth = 'width' in props ? props.width : props.size
    const rawHeight = 'height' in props ? props.height : props.size

    const width = typeof rawWidth === 'number' ? `${rawWidth}px` : rawWidth
    const height = typeof rawHeight === 'number' ? `${rawHeight}px` : rawHeight

    return {
        minWidth: width,
        minHeight: height,
        maxWidth: width,
        maxHeight: height,
        width,
        height,
        transition: 'all 400ms ease-in-out',
        ...props.style,
    }
}
